import JSZip from 'jszip'

const getExtensionFromUrl = (url = '') => {
  const sanitizedUrl = url.split('?')[0]
  const match = sanitizedUrl.match(/\.([a-z0-9]+)$/i)
  return match?.[1]?.toLowerCase() || null
}

const getExtensionFromMimeType = (mimeType = '') => {
  const mimeMap = {
    'image/jpeg': 'jpeg',
    'image/jpg': 'jpg',
    'image/png': 'png',
    'image/webp': 'webp',
    'image/gif': 'gif',
    'video/mp4': 'mp4',
    'video/webm': 'webm',
    'video/quicktime': 'mov',
    'video/x-msvideo': 'avi',
    'video/x-ms-wmv': 'wmv',
  }

  return mimeMap[mimeType.toLowerCase()] || null
}

const getMediaMeta = (url, mimeType = '') => {
  const extension = getExtensionFromUrl(url) || getExtensionFromMimeType(mimeType)
  const isVideo =
    mimeType.startsWith('video/') || ['mp4', 'mov', 'avi', 'wmv', 'webm'].includes(extension)

  return {
    extension: extension || (isVideo ? 'mp4' : 'jpeg'),
    label: isVideo ? 'Video' : 'Image',
  }
}

export const createAndDownloadZip = async ({
  text,
  imagePath,
  carouselImages,
  textKind,
  topic,
  url,
}) => {
  if (!text && !imagePath) {
    return false
  }
  const zip = new JSZip()

  if (text) {
    zip.file(`${topic} ${textKind} Text.txt`, text)
  }

  if (url) {
    zip.file(`${topic} Link.txt`, url)
  }

  if (carouselImages && carouselImages.length > 0) {
    try {
      for (let i = 0; i < carouselImages.length; i++) {
        const imageUrl = carouselImages[i]
        const response = await fetch(imageUrl)
        const buffer = await response.arrayBuffer()
        if (buffer) {
          const imageNumber = i + 1
          zip.file(`${topic} ${textKind} Image ${imageNumber}.jpeg`, buffer)
        }
      }
    } catch (error) {
      return false
    }
  } else if (imagePath) {
    try {
      const response = await fetch(imagePath)
      const buffer = await response.arrayBuffer()
      if (buffer) {
        const { extension, label } = getMediaMeta(
          imagePath,
          response.headers.get('content-type') || ''
        )
        zip.file(`${topic} ${textKind} ${label}.${extension}`, buffer)
      }
    } catch (error) {
      return false
    }
  }

  const blob = await zip.generateAsync({ type: 'blob' })
  const objectUrl = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = objectUrl
  link.setAttribute('download', `${topic} ${textKind}` + '.zip')
  document.body.appendChild(link)
  link.click()
  return true
}
